import { ProjectRegistrantCounts } from '@/types/registration.types';
import { Get } from '../helpers';

export default function GetEventRegistrantCounts({
  channel,
  projectUuid,
  signal,
}: {
  channel: number;
  projectUuid: string;
  signal?: AbortSignal;
}) {
  return Get<ProjectRegistrantCounts>({
    url: `/v4/admin/attendees/${channel}/${projectUuid}/get-counts`,
    signal,
  });
}
